<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      label-width="140px"
      labelPosition="left"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_scmCode') || '厂商'">
            <el-input v-model="formData.scmName" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_custCode') || '客户'">
            <el-input v-model="formData.custName" readonly> </el-input>
            <el-input v-model="formData.custOrderNoList" readonly class="mt-1">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_brand') || '品牌'">
            <el-input v-model="formData.brandName" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('table_label_trip_type') || '出差目的'">
            <el-input v-model="formData.v_tripType" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_tripPurpose') || '预计解决什么问题'"
          >
            <el-input v-model="formData.tripPurpose" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_visitPerson') || '对方人员'">
            <el-input
              v-model="formData.visitPerson"
              :placeholder="
                !disabled ? $l('INDEX.tips_input_placeholder') || '请输入' : ''
              "
              size="mini"
              :readonly="disabled"
              maxlength="1000"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_reportDescription') || '报告内容'"
          >
            <div v-if="!disabled" @paste="handlePaste">
              <quill-editor
                ref="myQuillEditor"
                v-model="formData.reportDescription"
                :options="editorOptions"
              />
            </div>
            <div v-if="disabled">
              <el-card shadow="never">
                <div
                  class="descHeight"
                  v-html="formData.reportDescription"
                ></div>
              </el-card>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  mixins: [EditLoading],
  components: { quillEditor },
  props: {
    disabled: { type: Boolean, default: false },
    formData: { type: Object, default: () => {} },
    tripReimbursementCode: { type: String, default: '' },
    tripReimbursementItemCode: { type: String, default: '' }
  },
  data() {
    return {
      rules: {
        tripType: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change'
          }
        ]
      },

      editorOptions: {
        modules: {
          toolbar: [
            'bold',
            'italic',
            'underline',
            'strike',
            { list: 'ordered' },
            { list: 'bullet' },
            { script: 'sub' },
            { script: 'super' },
            { color: [] },
            { background: [] },

            { size: ['small', false, 'large', 'huge'] }
          ]
        }
      },

      departureCityParams: { dictType: 'tripCity' },
      tripTypeParams: { dictType: 'tripType' }
    }
  },
  mounted() {},
  methods: {
    // 监听粘贴操作
    handlePaste(event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null
      if (!items || items.length === 0) return

      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (file) {
        this.loadingOpen()
        let quill = this.$refs.myQuillEditor.quill
        this.$api
          .SYS_UPLOAD(file)
          .then((res) => {
            let length = quill.getSelection().index //光标位置
            // 插入图片地址
            quill.insertEmbed(length, 'image', res.body.url)
            // 光标后移一位
            quill.setSelection(length + 1)
            this.loadingClose()
          })
          .catch(() => {
            this.loadingClose()
          })
        //阻止默认行为即不让剪贴板内容在div中显示出来
        event.preventDefault()
        return
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
::v-deep .ql-editor {
  height: 350px;
}
.descHeight {
  height: 350px;
  overflow-x: auto;
}
.showTitle {
  font-size: 14px;
  color: $color-text-sub;
  width: 120px;
}
.showText {
  font-size: 14px;
  color: $color-text-normal;
  width: 100%;
}
</style>
